import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut'
import { createBrowserRouter } from "react-router-dom";
import Productos from '../Pages/Productos/Productos'
import Usuarios from '../Pages/Usuarios/Usuarios'
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import Eventos from "./Eventos/Eventos";
import Galeria from "./Galeria/Galeria";
import PageDetail from '../Pages/PageDetail/PageDetail';
import VerificarAfiliado from './Afiliado/VerificarAfiliado';
import CentrosPage from './Centros/CentrosPage';
import CentrosServicios from './CentrosServicios/CentrosServicios';
import Configuracion from './Configuracion/Configuracion';
import QuienesSomosPage from './QuienesSomos/QuienesSomosPage';
import Politicas from './Politicas/Politicas';
import PoliticasPublica from './PoliticasPublica/PoliticasPublica';
import LibroReclamaciones from './LibroReclamaciones/LibroReclamaciones';
import LibroReclamacionesAdmin from './LibroReclamacionesAdmin/LibroReclamacionesAdmin';

export const router = createBrowserRouter([

    {
        path: "/",
        element: <IndexLayout />,

    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: [
            {
                path: `/producto/:idProducto/:producto`,
                element: <PageDetail />,
            },
            {
                path: `/verificar-afiliado`,
                element: <VerificarAfiliado />,
            },
            {
                path: `/afiliado`,
                element: <VerificarAfiliado />,
            },
            {
                path: `/centros`,
                element: <CentrosPage />,
            },
            {
                path: `/quienes-somos`,
                element: <QuienesSomosPage />,
            },
            {
                path: `/acerca-de-dxn`,
                element: <QuienesSomosPage />,
            },
            {
                path: `/nosotros`,
                element: <QuienesSomosPage />,
            },
            {
                path: `/politicas`,
                element: <PoliticasPublica />,
            },
            {
                path: `/politica/:idPolitica`,
                element: <PoliticasPublica />,
            },
            {
                path: `/terminos-y-condiciones`,
                element: <PoliticasPublica />,
            },
            {
                path: `/libro-de-reclamaciones`,
                element: <LibroReclamaciones />,
            },
            {
                path: `/libro-reclamaciones`,
                element: <LibroReclamaciones />,
            },
            {
                path: `/libro-de-visitas`,
                element: <LibroReclamaciones />,
            },
            {
                path: `/libro-visitas`,
                element: <LibroReclamaciones />,
            },
        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
            },
            {
                path: `/dashboard/productos`,
                element: <Productos />,
            },
            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
            },
            {
                path: `/dashboard/contacto`,
                element: <Contacto />,
            },
            {
                path: `/dashboard/categorias`,
                element: <Categorias />,
            },
            {
                path: `/dashboard/codigos`,
                element: <Codigos />,
            },
            {
                path: `/dashboard/eventos`,
                element: <Eventos />,
            },
            {
                path: `/dashboard/galeria`,
                element: <Galeria />,
            },
            {
                path: `/dashboard/configuracion`,
                element: <Configuracion />,
            },
            {
                path: `/dashboard/politicas`,
                element: <Politicas />,
            },
            {
                path: `/dashboard/libro-reclamaciones`,
                element: <LibroReclamacionesAdmin />,
            },
            {
                path: `/dashboard/reclamaciones`,
                element: <LibroReclamacionesAdmin />,
            },
            {
                path: `/dashboard/libro-de-reclamaciones`,
                element: <LibroReclamacionesAdmin />,
            },
            {
                path: `/dashboard/libro-visitas`,
                element: <LibroReclamacionesAdmin />,
            },
        ],
    },


]);
